/**
 * O que cada cor quer dizer, escrito uma vez (F156). A regra em uma frase:
 * **verde não é "bom", é "terminou"**. A Ajuda do site e a do celular leem
 * daqui.
 */
export const TONE_GLOSSARY = [
    {
        tone: 'neutral',
        label: 'Cinza',
        what: 'Ainda não vale: é rascunho, ou não começou.',
    },
    {
        tone: 'info',
        label: 'Azul',
        what: 'Está andando, e alguém ainda precisa fazer alguma coisa.',
    },
    {
        tone: 'warning',
        label: 'Amarelo',
        what: 'Pede atenção: um prazo, uma entrega que não chegou, uma cobrança.',
    },
    {
        tone: 'success',
        label: 'Verde',
        what: 'Terminou. Não quer dizer "bom" — quer dizer que aquele documento chegou ao fim do caminho dele.',
    },
    {
        tone: 'danger',
        label: 'Vermelho',
        what: 'Acabou mal ou foi desfeito: recusado, cancelado, ou um título atrasado.',
    },
];
/** Os três documentos de venda, para quem nunca usou o produto. */
export const SALES_KIND_GLOSSARY = {
    quote: 'Uma proposta. Ganha número quando é enviado, e pode segurar a mercadoria se for marcado para reservar.',
    order: 'Um compromisso de entregar. É dele que a mercadoria sai.',
    sale: 'A venda de balcão: quando é registrada, já acabou — o cliente levou e o dinheiro entrou.',
};
/** As situações de venda na ordem da Ajuda: orçamento, depois pedido, depois venda. */
export const sortStatusesForGlossary = (byKind) => byKind.quote.concat(byKind.order.filter((status) => !byKind.quote.includes(status)), byKind.sale.filter((status) => !byKind.quote.includes(status) && !byKind.order.includes(status)));
//# sourceMappingURL=glossary.js.map